module.exports = __webpack_public_path__ + "assets/img/lx_logo.4c8f2ec7.png";